import { Link } from 'react-router-dom';
import { ChefHat, Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2A1A14] text-white py-16" data-testid="footer">
      {/* Cottage Food Disclosure */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-12">
        <div className="flex justify-center">
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_spice-ball-bakery/artifacts/4sc0wdr2_Screenshot_20260805-103005.Chrome.png"
            alt="Arizona Cottage Food Disclosure - The Apron, LLC, Registration #CF-120291"
            className="max-w-xs rounded-sm shadow-lg"
            data-testid="cottage-food-label"
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <ChefHat className="w-8 h-8 text-[#D4A574]" />
              <span className="font-heading text-2xl font-semibold">
                The Apron
              </span>
            </Link>
            <p className="text-white/70 leading-relaxed mb-6 max-w-sm">
              Handcrafted Sicilian Cookies made with love. 
              Bringing the taste of Sicily to your home.
            </p>
            <p className="text-sm text-white/50">
              The Apron, LLC
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4 text-[#D4A574]">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-white/70 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/#products" className="text-white/70 hover:text-white transition-colors">
                  Shop
                </Link>
              </li>
              <li>
                <Link to="/#about" className="text-white/70 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-white/70 hover:text-white transition-colors">
                  Track Order
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading text-lg font-semibold mb-4 text-[#D4A574]">
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-white/70">
                <Mail className="w-5 h-5 text-[#D4A574]" />
                <a href="mailto:theapronllc@gmail.com" className="hover:text-white transition-colors">
                  theapronllc@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <Phone className="w-5 h-5 text-[#D4A574]" />
                <a href="tel:7163410950" className="hover:text-white transition-colors">
                  (716) 341-0950
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="w-5 h-5 text-[#D4A574] mt-0.5" />
                <span>
                  Marana, AZ
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Allergen Notice */}
        <div className="border-t border-white/10 mt-12 pt-6 pb-4">
          <p className="text-white/60 text-sm text-center" data-testid="footer-allergen-notice">
            <span className="font-medium">Allergen Notice:</span> Our products contain dairy and may also contain or have been prepared alongside nuts and/or nut oils.
          </p>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            {currentYear} The Apron, LLC. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="/" className="text-white/50 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/" className="text-white/50 hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
